/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';

export interface ExternalCostsControllerFindById$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * External cost ID
 */
  id: string;
}

export function externalCostsControllerFindById(http: HttpClient, rootUrl: string, params: ExternalCostsControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerFindById.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreExternalCostResponseDto>;
    })
  );
}

externalCostsControllerFindById.PATH = '/o2-core/external-costs/{tenant}/id/{id}';
